import { manualLifecycleTransitions, type ManualLifecycleTransition } from '@brimo/shared';

/**
 * Every stage is a target by hand, from every other stage (D-333); „Call gebucht" set here is a plain status
 * change with reason, no booking.
 */
export type LifecycleTarget = ManualLifecycleTransition;

const DEFAULT_TARGET: LifecycleTarget = 'follow_up';

/** The radio cards: all stages except the current one (of a single contact). */
export function lifecycleTargetsFor(current: string | null): LifecycleTarget[] {
  return manualLifecycleTransitions.filter((key) => key !== current);
}

/** The preselected target: the board's drop column, else „Follow Up", never the current stage. */
export function initialLifecycleTarget(
  current: string | null,
  preselect: LifecycleTarget | undefined,
): LifecycleTarget {
  const targets = lifecycleTargetsFor(current);
  if (preselect !== undefined && targets.includes(preselect)) return preselect;
  return targets.includes(DEFAULT_TARGET) ? DEFAULT_TARGET : (targets[0] ?? DEFAULT_TARGET);
}
